<template>
  <div>
    <template v-if="data != null && dataChartDay != null && dataChartHour != null && dataChartMinute != null">
      <v-row>
        <v-col cols="12" align="center">
          <v-btn :elevation="6" outlined :x-small="windowWidth < 400 ? true : false" :small="windowWidth > 400 && windowWidth < 800 ? true : false" class="ma-2" dark color="primary">
            {{ $t("donut.actual") }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="4" lg="3" align="center">
          <v-row no-gutters>
            <v-col cols="12">
              <h3 class="text-center">{{ $t("home.dashboardChart.pieCharts.singleName[0]") }}</h3>
            </v-col>

            <v-col cols="12">
              <ApexGradientDonutChart2
                :data="data.currentLoad"
                :colors="[this.colors.fromGrid, this.colors.fve, this.colors.discharging]"
                :units="'kW'"
                :label="[
                  $t('home.dashboardChart.Charts2_PieChart.currentLoad.y1'), //
                  $t('home.dashboardChart.Charts2_PieChart.currentLoad.y2'), //
                  $t('home.dashboardChart.Charts2_PieChart.currentLoad.y3'),
                ]"
                :header="$t('home.dashboardChart.pieCharts.singleName[0]')"
                :width="600"
                :dark="$vuetify.theme.dark"
              >
              </ApexGradientDonutChart2>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="3" align="center">
          <v-row no-gutters>
            <v-col cols="12">
              <h3 class="text-center">{{ $t("home.dashboardChart.pieCharts.singleName[1]") }}</h3>
            </v-col>

            <v-col cols="12">
              <ApexGradientDonutChart2
                :data="data.currentPV"
                :colors="[this.colors.consumption, this.colors.toGrid, this.colors.charging]"
                :units="'kW'"
                :label="[
                  $t('home.dashboardChart.Charts2_PieChart.pv.y1'), //
                  $t('home.dashboardChart.Charts2_PieChart.pv.y2'), //
                  $t('home.dashboardChart.Charts2_PieChart.pv.y3'), //
                ]"
                :header="$t('home.dashboardChart.pieCharts.singleName[1]')"
                :width="600"
                :dark="$vuetify.theme.dark"
              >
              </ApexGradientDonutChart2
            ></v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" align="center">
          <v-btn :elevation="displayInfo === 1 ? 6 : 0" outlined :x-small="windowWidth < 400 ? true : false" :small="windowWidth > 400 && windowWidth < 800 ? true : false" class="ma-2" dark @click="changeDisplayInfo(1)" :color="displayInfo === 1 ? 'primary' : 'grey'">
            {{ $t("donut.today") }}
          </v-btn>
          <v-btn :elevation="displayInfo === 2 ? 6 : 0" outlined :x-small="windowWidth < 400 ? true : false" :small="windowWidth > 400 && windowWidth < 800 ? true : false" class="ma-2" dark @click="changeDisplayInfo(2)" :color="displayInfo === 2 ? 'primary' : 'grey'">
            {{ $t("donut.yesterday") }}
          </v-btn>
          <v-btn :elevation="displayInfo === 3 ? 6 : 0" outlined :x-small="windowWidth < 400 ? true : false" :small="windowWidth > 400 && windowWidth < 800 ? true : false" class="ma-2" dark @click="changeDisplayInfo(3)" :color="displayInfo === 3 ? 'primary' : 'grey'">
            {{ $t("donut.thisWeek") }}
          </v-btn>
          <v-btn :elevation="displayInfo === 4 ? 6 : 0" outlined :x-small="windowWidth < 400 ? true : false" :small="windowWidth > 400 && windowWidth < 800 ? true : false" class="ma-2" dark @click="changeDisplayInfo(4)" :color="displayInfo === 4 ? 'primary' : 'grey'">
            {{ $t("donut.thisMonth") }}
          </v-btn>
          <v-btn :elevation="displayInfo === 5 ? 6 : 0" outlined :x-small="windowWidth < 400 ? true : false" :small="windowWidth > 400 && windowWidth < 800 ? true : false" class="ma-2" dark @click="changeDisplayInfo(5)" :color="displayInfo === 5 ? 'primary' : 'grey'">
            {{ $t("donut.this2Month") }}
          </v-btn>
          <v-btn :elevation="displayInfo === 6 ? 6 : 0" outlined :x-small="windowWidth < 400 ? true : false" :small="windowWidth > 400 && windowWidth < 800 ? true : false" class="ma-2" dark @click="changeDisplayInfo(6)" :color="displayInfo === 6 ? 'primary' : 'grey'">
            {{ $t("donut.thisYear") }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="8" md="3" lg="3">
          <template v-if="displayInfo === 0"> </template>
          <template v-else-if="displayInfo === 1">
            <DonutChartsInfoPanel :colors="colors" :data="dataDonutChartDay" />
          </template>
          <template v-else-if="displayInfo === 2">
            <DonutChartsInfoPanel :colors="colors" :data="dataDonutChartYesterday" />
          </template>
          <template v-else-if="displayInfo === 3">
            <DonutChartsInfoPanel :colors="colors" :data="dataDonutChartWeek" />
          </template>
          <template v-else-if="displayInfo === 4">
            <DonutChartsInfoPanel :colors="colors" :data="dataDonutChartMonth" />
          </template>
          <template v-else-if="displayInfo === 5">
            <DonutChartsInfoPanel :colors="colors" :data="dataDonutChartLast2Month" />
          </template>
          <template v-else-if="displayInfo === 6">
            <DonutChartsInfoPanel :colors="colors" :data="dataDonutChartYear" />
          </template>
        </v-col>

        <template v-if="dataDonutChartChossen != null">
          <v-col cols="12" sm="6" md="4" lg="3" align="center">
            <v-row no-gutters>
              <v-col cols="12">
                <h3 class="text-center">
                  <template v-if="displayInfo === 1">
                    {{ $t("donut.chart.todayFVE") }}
                  </template>
                  <template v-else-if="displayInfo === 2">
                    {{ $t("donut.chart.yesterdayFVE") }}
                  </template>
                  <template v-else-if="displayInfo === 3">
                    {{ $t("donut.chart.last7daysFVE") }}
                  </template>
                  <template v-else-if="displayInfo === 4">
                    {{ $t("donut.chart.lastmonthFVE") }}
                  </template>
                  <template v-else-if="displayInfo === 5">
                    {{ $t("donut.chart.last2monthFVE") }}
                  </template>
                  <template v-else-if="displayInfo === 6">
                    {{ $t("donut.chart.lastyearFVE") }}
                  </template>
                </h3>
              </v-col>

              <v-col cols="12">
                <ApexGradientDonutChart2
                  :data="[parseFloat(this.dataDonutChartChossen.inverterConsumption), parseFloat(this.dataDonutChartChossen.batCharged), parseFloat(this.dataDonutChartChossen.gridOverflows)]"
                  :colors="[this.colors.consumption, this.colors.charging, this.colors.toGrid]"
                  :units="'kWh'"
                  :label="[$t('donut.chart.legend.consumption'), $t('donut.chart.legend.charging'), $t('donut.chart.legend.toGrid')]"
                  :header="'A'"
                  :width="600"
                  :dark="$vuetify.theme.dark"
                >
                </ApexGradientDonutChart2>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3" align="center">
            <v-row no-gutters>
              <v-col cols="12">
                <h3 class="text-center">
                  <template v-if="displayInfo === 1">
                    {{ $t("donut.chart.todayConsumption") }}
                  </template>
                  <template v-else-if="displayInfo === 2">
                    {{ $t("donut.chart.yesterdayConsumption") }}
                  </template>
                  <template v-else-if="displayInfo === 3">
                    {{ $t("donut.chart.last7daysConsumption") }}
                  </template>
                  <template v-else-if="displayInfo === 4">
                    {{ $t("donut.chart.lastmonthConsumption") }}
                  </template>
                  <template v-else-if="displayInfo === 5">
                    {{ $t("donut.chart.last2monthConsumption") }}
                  </template>
                  <template v-else-if="displayInfo === 6">
                    {{ $t("donut.chart.lastyearConsumption") }}
                  </template>
                </h3>
              </v-col>

              <v-col cols="12">
                <ApexGradientDonutChart2
                  :data="[parseFloat(this.dataDonutChartChossen.grid), parseFloat(this.dataDonutChartChossen.inverterConsumptionBAT), parseFloat(this.dataDonutChartChossen.inverterConsumptionFVE)]"
                  :colors="[this.colors.fromGrid, this.colors.discharging, this.colors.fve]"
                  :units="'kWh'"
                  :label="[$t('donut.chart.legend.fromGrid'), $t('donut.chart.legend.discharging'), $t('donut.chart.legend.fve')]"
                  :header="'B'"
                  :width="600"
                  :dark="$vuetify.theme.dark"
                >
                </ApexGradientDonutChart2>
              </v-col>
            </v-row>
          </v-col>
        </template>
      </v-row>
    </template>
    <template v-else>
      <LoadingData />
    </template>

    <UpgradeCore />
  </div>
</template>

<script>
import UpgradeCore from "../../components/upgrade/UpgradeCore.vue";

import ApexGradientDonutChart2 from "../../components/charts/apexcharts/ApexGradientDonutChart2.vue";

import LoadingData from "../../components/LoadingData.vue";

import { ServiceClient } from "../../service_client/index.js";

import { mapState } from "vuex";

import DonutChartsInfoPanel from "../../components/charts/donutCharts/InfoPanel.vue";

import { isDaylightSavingTime } from "../../time.js";

export default {
  name: "PieCharts2",
  props: {},
  components: {
    ApexGradientDonutChart2,
    DonutChartsInfoPanel,
    LoadingData,
    UpgradeCore,
  },
  data() {
    return {
      displayInfo: 1,

      timer: null,
      timerChart: null,

      mobile: false,

      colors: {
        consumption: "#F44336",
        inverter: "#009688",
        fromGrid: "#9C27B0",
        toGrid: "#2196F3",
        fve: "#FFC107",
        charging: "#8BC34A",
        discharging: "#4CAF50",
      },

      dataDonutChartChossen: null, // Aktuální zvolené data
      dataDonutChartYear: null,
      dataDonutChartLast2Month: null,
      dataDonutChartMonth: null,
      dataDonutChartWeek: null,
      dataDonutChartYesterday: null,
      dataDonutChartDay: null,
      dataDonutChartMinute: null, // Pomocný objekt poslední hodina

      date: null, // datetime
      data: null,

      dataChartDay: null,
      dataChartHour: null,
      dataChartMinute: null,

      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    };
  },
  created() {
    this.getBreakpoints();

    this.getData();
    this.getChartData();

    setTimeout(() => {
      this.switchDonutChart();
    }, 250);
  },
  mounted() {
    this.pollData();
    this.pollChartData();

    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  methods: {
    changeDisplayInfo(number) {
      this.displayInfo = number;
    },
    switchDonutChart() {
      switch (this.displayInfo) {
        case 1:
          this.dataDonutChartChossen = this.dataDonutChartDay;
          break;

        case 2:
          this.dataDonutChartChossen = this.dataDonutChartYesterday;
          break;

        case 3:
          this.dataDonutChartChossen = this.dataDonutChartWeek;
          break;

        case 4:
          this.dataDonutChartChossen = this.dataDonutChartMonth;
          break;

        case 5:
          this.dataDonutChartChossen = this.dataDonutChartLast2Month;
          break;

        case 6:
          this.dataDonutChartChossen = this.dataDonutChartYear;
          break;

        default:
          break;
      }
    },
    onResize() {
      this.getBreakpoints();
    },
    getBreakpoints() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;

      if (this.windowWidth < 768) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
    },
    pollData() {
      this.timer = setInterval(() => {
        this.getData();
      }, 5000);
    },
    pollChartData() {
      this.timerChart = setInterval(() => {
        this.getChartData();
      }, 60000);
    },
    getData() {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("chartpies"), null, null, "GET")
        .then((data) => {
          this.data = data;
        })
        .catch((error) => {
          this.data = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    getChartData() {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("chart"), null, "?time=d&type=E&limit=365", "GET")
        .then((data) => {
          this.dataChartDay = data;

          this.processChartDayData(this.dataChartDay);

          this.dataDonutChartYear = this.calculateChartData(this.dataDonutChartYear);
          this.dataDonutChartLast2Month = this.calculateChartData(this.dataDonutChartLast2Month);
          this.dataDonutChartMonth = this.calculateChartData(this.dataDonutChartMonth);
          this.dataDonutChartWeek = this.calculateChartData(this.dataDonutChartWeek);
          this.dataDonutChartYesterday = this.calculateChartData(this.dataDonutChartYesterday);
        })
        .catch((error) => {
          this.dataChartDay = ServiceClient.handleUnauthorized(error, this.$router);
        });

      let date = new Date();

      if (isDaylightSavingTime(date)) {
        date.setHours(date.getHours() + 2); // Letní čas (UTC+2)
      } else {
        date.setHours(date.getHours() + 1); // Zimní čas (UTC+1)
      }

      // YYYY-MM-DDTHH:mm:ss.sssZ
      date = date.toISOString();

      this.date = date;

      let dt1 =
        this.date.substring(0, 4) + //
        this.date.substring(5, 7) + //
        this.date.substring(8, 10) + //
        "0000";
      let dt2 =
        this.date.substring(0, 4) + //
        this.date.substring(5, 7) + //
        this.date.substring(8, 10) + //
        this.date.substring(11, 13) + //
        this.date.substring(14, 16);
      let dt3 =
        this.date.substring(0, 4) + //
        this.date.substring(5, 7) + //
        this.date.substring(8, 10) + //
        this.date.substring(11, 13) + //
        "00";
      let dt4 =
        this.date.substring(0, 4) + //
        this.date.substring(5, 7) + //
        this.date.substring(8, 10) + //
        this.date.substring(11, 13) + //
        this.date.substring(14, 16);

      ServiceClient.dataCore(ServiceClient.getAPIUrl("chart"), null, "?time=H&type=E" + "&dt1=" + dt1 + "&dt2=" + dt2, "GET")
        .then((data) => {
          this.dataChartHour = data;

          this.processChartHourData(this.dataChartHour);

          this.dataDonutChartDay = this.calculateChartData(this.dataDonutChartDay);

          ServiceClient.dataCore(ServiceClient.getAPIUrl("chart"), null, "?time=M&type=E" + "&dt1=" + dt3 + "&dt2=" + dt4, "GET")
            .then((data) => {
              this.dataChartMinute = data;

              this.processChartMinuteData(this.dataChartMinute);

              this.dataChartMinute = this.calculateChartData(this.dataChartMinute);

              this.dataDonutChartDay.load = (parseFloat(this.dataDonutChartDay.load) + parseFloat(this.dataDonutChartMinute.load)).toFixed(3);
              this.dataDonutChartDay.grid = (parseFloat(this.dataDonutChartDay.grid) + parseFloat(this.dataDonutChartMinute.grid)).toFixed(3);
              this.dataDonutChartDay.pv = (parseFloat(this.dataDonutChartDay.pv) + parseFloat(this.dataDonutChartMinute.pv)).toFixed(3);
              this.dataDonutChartDay.bat = (parseFloat(this.dataDonutChartDay.bat) + parseFloat(this.dataDonutChartMinute.bat)).toFixed(3);
              this.dataDonutChartDay.gridOverflows = (parseFloat(this.dataDonutChartDay.gridOverflows) + parseFloat(this.dataDonutChartMinute.gridOverflows)).toFixed(3);
              this.dataDonutChartDay.batCharged = (parseFloat(this.dataDonutChartDay.batCharged) + parseFloat(this.dataDonutChartMinute.batCharged)).toFixed(3);
            })
            .catch((error) => {
              this.dataChartMinute = ServiceClient.handleUnauthorized(error, this.$router);
            });
        })
        .catch((error) => {
          this.dataChartHour = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    processChartDayData(data) {
      const reversedData = ["labels", "load", "grid", "pv", "bat", "gridOverflows", "batCharged"];

      reversedData.forEach((key) => {
        data[key] = data[key].reverse();
      });

      // This must have same name as state defined above dataDonutChartYear ... dataDonutChartDay
      const periods = [
        { name: "Yesterday", limit: 1 },
        { name: "Week", limit: 7 },
        { name: "Month", limit: 31 },
        { name: "Last2Month", limit: 62 },
        { name: "Year", limit: 365 },
      ];

      periods.forEach((period) => {
        this[`dataDonutChart${period.name}`] = {
          labels: 0,
          load: 0,
          grid: 0,
          pv: 0,
          bat: 0,
          gridOverflows: 0,
          batCharged: 0,
        };
      });

      // V ECCCU se vzorek day přidá, až po dokončením dne
      for (let index = 0; index < data.labels.length; index++) {
        periods.forEach((period) => {
          if (index < period.limit) {
            this[`dataDonutChart${period.name}`].load += data.load[index];
            this[`dataDonutChart${period.name}`].grid += data.grid[index];
            this[`dataDonutChart${period.name}`].pv += data.pv[index];
            this[`dataDonutChart${period.name}`].bat += data.bat[index];
            this[`dataDonutChart${period.name}`].gridOverflows += data.gridOverflows[index];
            this[`dataDonutChart${period.name}`].batCharged += data.batCharged[index];
          }
        });
      }

      periods.forEach((period) => {
        Object.keys(this[`dataDonutChart${period.name}`]).forEach((key) => {
          this[`dataDonutChart${period.name}`][key] = this[`dataDonutChart${period.name}`][key].toFixed(3);
        });
      });

      reversedData.forEach((key) => {
        data[key] = data[key].reverse();
      });
    },
    processChartHourData(data) {
      const reversedData = ["labels", "load", "grid", "pv", "bat", "gridOverflows", "batCharged"];

      reversedData.forEach((key) => {
        data[key] = data[key].reverse();
      });

      this.dataDonutChartDay = {
        labels: 0,
        load: 0,
        grid: 0,
        pv: 0,
        bat: 0,
        gridOverflows: 0,
        batCharged: 0,
      };

      for (let index = 0; index < data.labels.length; index++) {
        this.dataDonutChartDay.load += data.load[index];
        this.dataDonutChartDay.grid += data.grid[index];
        this.dataDonutChartDay.pv += data.pv[index];
        this.dataDonutChartDay.bat += data.bat[index];
        this.dataDonutChartDay.gridOverflows += data.gridOverflows[index];
        this.dataDonutChartDay.batCharged += data.batCharged[index];
      }

      this.dataDonutChartDay.load = this.dataDonutChartDay.load.toFixed(3);
      this.dataDonutChartDay.grid = this.dataDonutChartDay.grid.toFixed(3);
      this.dataDonutChartDay.pv = this.dataDonutChartDay.pv.toFixed(3);
      this.dataDonutChartDay.bat = this.dataDonutChartDay.bat.toFixed(3);
      this.dataDonutChartDay.gridOverflows = this.dataDonutChartDay.gridOverflows.toFixed(3);
      this.dataDonutChartDay.batCharged = this.dataDonutChartDay.batCharged.toFixed(3);

      reversedData.forEach((key) => {
        data[key] = data[key].reverse();
      });
    },
    processChartMinuteData(data) {
      const reversedData = ["labels", "load", "grid", "pv", "bat", "gridOverflows", "batCharged"];

      reversedData.forEach((key) => {
        data[key] = data[key].reverse();
      });

      this.dataDonutChartMinute = {
        labels: 0,
        load: 0,
        grid: 0,
        pv: 0,
        bat: 0,
        gridOverflows: 0,
        batCharged: 0,
      };

      for (let index = 0; index < data.labels.length; index++) {
        this.dataDonutChartMinute.load += data.load[index];
        this.dataDonutChartMinute.grid += data.grid[index];
        this.dataDonutChartMinute.pv += data.pv[index];
        this.dataDonutChartMinute.bat += data.bat[index];
        this.dataDonutChartMinute.gridOverflows += data.gridOverflows[index];
        this.dataDonutChartMinute.batCharged += data.batCharged[index];
      }

      this.dataDonutChartMinute.load = this.dataDonutChartMinute.load.toFixed(2);
      this.dataDonutChartMinute.grid = this.dataDonutChartMinute.grid.toFixed(2);
      this.dataDonutChartMinute.pv = this.dataDonutChartMinute.pv.toFixed(2);
      this.dataDonutChartMinute.bat = this.dataDonutChartMinute.bat.toFixed(2);
      this.dataDonutChartMinute.gridOverflows = this.dataDonutChartMinute.gridOverflows.toFixed(2);
      this.dataDonutChartMinute.batCharged = this.dataDonutChartMinute.batCharged.toFixed(2);

      reversedData.forEach((key) => {
        data[key] = data[key].reverse();
      });
    },
    calculateChartData(data) {
      let load = data.load;
      let grid = data.grid;
      let pv = data.pv;
      let bat = data.bat;
      let gridOverflows = data.gridOverflows;
      let batCharged = data.batCharged;

      let inverterConsumption = parseFloat(load) - parseFloat(grid);
      if (inverterConsumption < 0) {
        inverterConsumption = 0;
      }

      let inverterTotal = parseFloat(inverterConsumption) + parseFloat(gridOverflows);

      let inverterConsumptionBAT = bat * 0.9;

      let inverterConsumptionFVE = inverterConsumption - inverterConsumptionBAT;
      if (inverterConsumptionFVE < 0) {
        inverterConsumptionFVE = 0;
      }

      inverterConsumption = inverterConsumption.toFixed(3);
      inverterConsumptionFVE = inverterConsumptionFVE.toFixed(3);
      inverterConsumptionBAT = inverterConsumptionBAT.toFixed(3);
      inverterTotal = inverterTotal.toFixed(3);

      let obj = {
        load: load,
        inverterConsumption: inverterConsumption,
        inverterConsumptionBAT: inverterConsumptionBAT,
        inverterConsumptionFVE: inverterConsumptionFVE,
        inverterTotal: inverterTotal,
        grid: grid,
        pv: pv,
        bat: bat,
        gridOverflows: gridOverflows,
        batCharged: batCharged,
      };

      return obj;
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.timerChart);

    window.removeEventListener("resize", this.onResize);
  },
  destroyed() {},
  watch: {
    displayInfo: function () {
      this.switchDonutChart();
    },
  },
};
</script>

<style scoped></style>
